/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 10:37:29
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


export default ({ label, list = [], color = [] }) => {
  return {
    title: {
      text: '三个品牌方向五级情感倾向内容条数及DB值占比',
      textAlign: 'center',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {},
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: label,
      axisLabel: { ...xAxisLabelColor },
    },
    yAxis: {
      type: 'value',
      axisLabel: { ...yAxisLabelColor },
    },
    series: list.map(({ name, list }, index) => {
      return {
        stack: 'a',
        name,
        barMaxWidth: 100,
        data: list.map((value, _index) => {
          const colorRow = color[_index] || []
          const iColor = colorRow[index]
          const itemStyle = iColor ? { color: iColor } : undefined
          return {
            value,
            itemStyle
          }
        }),
        type: 'bar',
      }
    }).reverse(),
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P6/chart.js